var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_89",
    "data-name": "Groupe 89",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.668,
    height: 18.628,
    viewBox: "0 0 27.668 18.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_173",
    "data-name": "Trac\\xE9 173",
    d: "M2.157,2.5a.657.657,0,0,0-.657.657V4.47a.657.657,0,0,0,.657.657H3.47a.657.657,0,0,0,.657-.657V3.157A.657.657,0,0,0,3.47,2.5Zm1.313.657H2.157V4.47H3.47Z",
    transform: "translate(-1.5 -2.5)",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_175",
    "data-name": "Trac\\xE9 175",
    d: "M2.157,2.5a.657.657,0,0,0-.657.657V4.47a.657.657,0,0,0,.657.657H3.47a.657.657,0,0,0,.657-.657V3.157A.657.657,0,0,0,3.47,2.5Zm1.313.657H2.157V4.47H3.47Z",
    transform: "translate(-1.5 5.501)",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_176",
    "data-name": "Trac\\xE9 176",
    d: "M2.157,2.5a.657.657,0,0,0-.657.657V4.47a.657.657,0,0,0,.657.657H3.47a.657.657,0,0,0,.657-.657V3.157A.657.657,0,0,0,3.47,2.5Zm1.313.657H2.157V4.47H3.47Z",
    transform: "translate(-1.5 13.501)",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_174",
    "data-name": "Trac\\xE9 174",
    d: "M5,4.034A1.089,1.089,0,0,1,6.136,3H26.583a1.089,1.089,0,0,1,1.136,1.034,1.089,1.089,0,0,1-1.136,1.034H6.136A1.089,1.089,0,0,1,5,4.034Zm1.136,7.237a1.038,1.038,0,1,0,0,2.068H26.583a1.038,1.038,0,1,0,0-2.068Zm0,8.271a1.038,1.038,0,1,0,0,2.068H26.583a1.038,1.038,0,1,0,0-2.068Z",
    transform: "translate(-0.051 -2.99)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon-list.c54c84ebaef985f5e7317cd1409ad0bb.svg";
export { ForwardRef as ReactComponent };